/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from "@mui/material/FormGroup";
import { TextInput, Services, Button, Text, Checkbox, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';

import { updateFormField } from '../../../actions/signup.js';
import Grid from "@mui/material/Grid";
import * as dates from "@simplybenefits/sb-dates";
import Tip from '../../../components/Tip.js';

class Trustee extends Component {
    state = {
        firstname: '',
        lastname: '',
        relationship: '',
        options: [ ...Services.selectFieldOptions.optionsWithSpouse(), i18n.t(tokens.labels.account.other) ],
        skipTrustee: false,
        acceptedTerms: false
    };

    async componentDidMount() {
        await this._checkBeneficiaries();

        if (this.props.trustee) {
            this.setState({
                firstname: this.props.trustee.firstname || '',
                lastname: this.props.trustee.lastname || '',
                relationship: this.props.trustee.relationship || ''
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.trustee) {
            this.setState({
                firstname: nextProps.trustee.firstname || '',
                lastname: nextProps.trustee.lastname || '',
                relationship: nextProps.trustee.relationship || ''
            });
        }
    }

    _getAge = (birthdate) => {
        birthdate = dates.getUTC(birthdate);

        return Math.floor(((dates.getUTC()) - birthdate) / (60 * 60 * 24 * 365));
    };

    /**
     * If all beneficiaries are over 18 then no trustee is required
     * @private
     */
    _checkBeneficiaries = () => {
        let skipTrustee = true;

        [ ...this.props.beneficiaries.primary, ...this.props.beneficiaries.contingent ].map((beneficiary) => {
            const age = this._getAge(beneficiary.birthdate);

            if (age < 18) {
                skipTrustee = false;
            }

            return null;
        });

        this.setState({
            skipTrustee
        });
    };

    _onBlur = (type) => {
        // update state with new form field value so it sticks when switching between views
        this.props.dispatch(updateFormField('trustee', type, this.state[type]));
    };

    _handleInputChange = (type, value) => {
        // make the saved state to false, since we have made edits
        this.props.setSavedState('trustee', false);

        this.setState({
            [type]: value
        });
    };

    _validateForm = async () => {
        if (this.state.skipTrustee) {
            return true;
        }

        const { firstname, lastname, relationship, acceptedTerms } = this.state;

        const firstnameError = await Services.validateInput('firstname', firstname);
        const lastnameError = await Services.validateInput('lastname', lastname);
        const relationshipError = await Services.validateInput('relationship', relationship);
        const trusteeAcceptedError = !acceptedTerms;

        if (trusteeAcceptedError) {
            alert(i18n.t(tokens.labels.signage.pleaseAcceptAndAcknowledgeChanges));
        }

        this.setState({
            firstnameError,
            lastnameError,
            relationshipError
        });

        if (
            firstnameError ||
            lastnameError ||
            relationshipError ||
            trusteeAcceptedError
        ) {
            return false;
        }

        return true;
    };

    _next = async () => {
        if (this.state.skipTrustee) {
            // make the saved state to false, since we have made edits
            this.props.setSavedState('trustee', true);
            this.props.stepCompletion(null, 'trustee', false);
            return;
        }

        const isFormValid = await this._validateForm();

        if (!isFormValid) {
            return;
        }

        // make the saved state to true, we have hit next and everything is valid
        this.props.setSavedState('trustee', true);

        this.props.stepCompletion(
            {
                firstname: this.state.firstname.trim(),
                lastname: this.state.lastname.trim(),
                relationship: localizationMaps.toEnglish("relationships", this.state.relationship.trim())
            },
            'trustee',
            false
        );
    };

    render() {
        const styles = {
            form: {
                display: 'flex',
                flexDirection: 'column'
            },
            visibilityIcon: {
                position: 'absolute',
                marginLeft: -30
            },
            stepperBtnContainer: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 30
            },
            stepperNextBtn: {
                float: 'right',
                marginRight: '5px !important'
            }
        };

        return (
            <div>
                <Text largest bold margin="0 0 10px 0">{ i18n.t(tokens.titles.trustee) }</Text>

                <div style={styles.form}>
                    <Tip
                        left
                        show={ this.props.tips.trusteeBreakdown }
                        close={ () => this.props.hideTip('trusteeBreakdown') }
                        customStyle={{ marginTop: -100 }}
                    >
                        { i18n.t(tokens.labels.signup.a) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.titles.trustee).toLowerCase() }</span> { i18n.t(tokens.labels.signup.personWhoWillManageBenefitsForMinors) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.parent) }</span>; { i18n.t(tokens.labels.signup.ifNoneAreLivingIndicateAResponsible) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.familyMember) }</span> { i18n.t(tokens.labels.or) } <span style={{ fontWeight: 'bold' }}>{ i18n.t(tokens.labels.signup.closeFriend) }</span>.
                    </Tip>

                    {
                        this.state.skipTrustee ?
                            <Text>{ i18n.t(tokens.labels.account.noTrusteeRequired) }</Text>
                            :
                            <React.Fragment>
                                <FormGroup row style={{ marginTop: 20 }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={ this.state.acceptedTerms }
                                                onChange={ () => this._handleInputChange('acceptedTerms', !this.state.acceptedTerms) }
                                                value="acceptedTerms"
                                                color="secondary"
                                            />
                                        }
                                        label={<Text avMedium>{ i18n.t(tokens.labels.signup.beneficiaryDesignations) }</Text>}
                                    />
                                </FormGroup>
                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <TextInput
                                            label={ i18n.t(tokens.labels.firstname) }
                                            autoFocus
                                            value={this.state.firstname}
                                            onBlur={() => this._onBlur('firstname')}
                                            onChange={(event) => this._handleInputChange('firstname', event.target.value)}
                                            error={Boolean(this.state.firstnameError)}
                                            helperText={this.state.firstnameError}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <TextInput
                                            label={ i18n.t(tokens.labels.lastname) }
                                            value={this.state.lastname}
                                            onBlur={() => this._onBlur('lastname')}
                                            onChange={(event) => this._handleInputChange('lastname', event.target.value)}
                                            error={Boolean(this.state.lastnameError)}
                                            helperText={this.state.lastnameError}
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <TextInput
                                        label={ i18n.t(tokens.labels.relationship) }
                                        value={this.state.relationship}
                                        onBlur={() => this._onBlur('relationship')}
                                        onChange={(event) => this._handleInputChange('relationship', event.target.value)}
                                        error={Boolean(this.state.relationshipError)}
                                        helperText={this.state.relationshipError}
                                        select
                                        selectOptions={this.state.options}
                                        fullWidth
                                    />
                                </Grid>
                            </React.Fragment>
                    }
                    <div style={styles.stepperBtnContainer}>
                        <Button
                            style={styles.stepperNextBtn}
                            onClick={this._next}
                            color="primary"
                        >
                            { i18n.t(tokens.buttons.continue) }
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

Trustee.propTypes = {
    firstname: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    lastname: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ]),
    relationship: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ])
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    trustee: state.signup.trustee,
    beneficiaries: state.signup.beneficiaries
});

export default connect(mapStateToProps)(Trustee);